<template lang="pug">
  .page
    .title album page.
    album-detail-partial(:editMode="editMode")
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AlbumDetailPartial from "@/components/partial/album/AlbumDetailPartial.vue";

export default {
  name: "AlbumEditPage",
  components: {AlbumDetailPartial},
  data() {
    return {
      editMode: true,
    };
  },
  created() {
    const id = this.$route.params.id;
    this.getDetailAlbum(id);
  },
  computed: {
    ...mapGetters("album", {
      album: "album",
    }),
  },
  methods: {
    ...mapActions("album", {
      getDetailAlbum: "getDetailAlbum"
    }),
  },
};
</script>